import { useMediaQuery, useTheme } from '@mui/material';
import { PanelResizeHandle } from 'react-resizable-panels';

export const ResizeHandle = ({ className }: { className?: string }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  if (isMobile) {
    return null;
  }
  return (
    <PanelResizeHandle
      hitAreaMargins={{ coarse: 15, fine: 5 }}
      className={`w-px h-full bg-gray-100 data-[resize-handle-state=hover]:bg-gray-400 data-[resize-handle-state=drag]:bg-gray-400 cursor-col-resize ${className ?? ''}`}
    />
  );
};
